<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()"
        v-if="convenio.idSituacaoConvenio != 9">
            Adicionar
        </b-button>
        <cronograma-recebimento-form
            operacaoProp="I"
            :convenio="convenio"
            :cronogramaRecebimento="cronogramaRecebimento"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></cronograma-recebimento-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import CronogramaRecebimentoForm from './CronogramaRecebimentoForm'

export default {
    components: {
        CronogramaRecebimentoForm
    },

    props: {
        convenio: Object,
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            cronogramaRecebimento: {
                idConvenio: 0,
                dtMesAno: null,
                idCronogramaRecebimento: 0,
                codSituacao: null,
                dtLiberacao: null,
                nuParcela: 1,
                percExecucao: null,
                nuValorRecebimento: 0,
                vcDescricao: null,
                vlLiberado: null
            },
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(cronogramaRecebimento){
            this.$store.dispatch('addRequest')
            let cronogramaRecebimentoDto = {
                idConvenio : this.$route.params.convenioId,
                codSituacao: cronogramaRecebimento.codSituacao,
                dtLiberacao:cronogramaRecebimento.dtLiberacao,
                dtMesAno:cronogramaRecebimento.dtMesAno,
                idCronogramaRecebimento:cronogramaRecebimento.idCronogramaRecebimento,
                nuParcela:cronogramaRecebimento.nuParcela,
                nuValorRecebimento: cronogramaRecebimento.nuValorRecebimento,
                nuValorRecebimento:cronogramaRecebimento.nuValorRecebimento,
                percExecucao:cronogramaRecebimento.percExecucao,
                vcDescricao:cronogramaRecebimento.vcDescricao,
                vlLiberado:cronogramaRecebimento.vlLiberado,
            }
            ConveniosServicos.InserirCronogramaRecebimento(cronogramaRecebimentoDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Cronograma inserido com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
